export const ZIndex = {
  ForStackingContext: 0,

  ProfileCamera: 1,
  ProfileImageBorder: 1,
  ReplyConfigMenu: 2,
  NavBar: 2,
  ReplyInput: 4,

  ViewerToolbar: 2,
  ViewerOption: 101,
  ViewerNavBar: -1,
  ViewerOptionBackground: 100,
  ViewerOptionFontSelector: 3,
  ViewerReply: 100,
  ViewerReReply: 200,
  ViewerEpisodeList: 101,
  ViewerEpisodeListBackground: 100,
  ViewerTextSelectPopup: 99,

  Preview: 3,
  Modal: 999,
  FixedHeader: 50,
  UserMenu: 100,
  BottomNavigation: 101,
  EventTabMenuSelector: 1,
  ReplyLikedByProfileIcon: 2,
  ReplyLikedByProfile: 1,
  CoverImageBorder: 1,
  CoverPrivateContentOpacity: 20,
  CoverBadge: 30,

  HomeProgressBar: 1,
  EditorTooltip: 10,
  Hidden: -10000,
  HomeSectionPrevNextButton: 2,
  NonMemberRestrict: 1,
  Maintenance: 9999,
  FullPageLoading: 8000,
  Background: -10,
  FancyShareInput: 10,
  BottomWindowWrapper: 100,

  TableThInTBody: 1,
  TableTh: 1000,
  TablePinnedTh: 1000,
  TablePinnedThPc: 1001,
  TableThead: 1000,

  SectionBannerBody: 1,

  DirittoStudioEmptyList: 10,

  FancyShareEditor: 999,
};
